export default "__VITE_ASSET__SwINJ7JY__"